import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Table } from 'reactstrap'
import { getCategoriesList } from '../../redux/actions/indexActions'
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai"
import { Link } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Button } from 'reactstrap'
import { MdAdd } from "react-icons/md"
import { Spinner } from "reactstrap"
import { Input } from "reactstrap"
import Pagination from '../../Components/Paginate';
import { CSVLink } from 'react-csv';
import { BiSolidFileExport } from 'react-icons/bi';

const Category = () => {
    const dispatch = useDispatch()
    const { AuthReducer: { auth }, indexReducer: { categories, loading, categoriesCount }, PermissionReducer: { allowedPermissions } } = useSelector(state => state)
    const [page, setPage] = useState(0);
    const [loading2, setLoading2] = useState(true);
    const [paginate, setPaginate] = useState(10);
    const [sort, setSort] = useState('desc');
    const [priority, setPriority] = useState("");
    const [search, setSearch] = useState('');
    const [refresh, setRefresh] = useState(0);
    const [prevData, setPrevData] = useState({
        value: "",
        idx: "",
    });
    const indexOfLastItem = (page + 1) * paginate;
    const indexOfFirstItem = indexOfLastItem - paginate;

    useEffect(() => {
        dispatch(getCategoriesList(auth?.token, paginate, page, search, sort, priority))
    }, [auth, paginate, page, search, sort, priority,refresh])

    const csvHead = [['name', 'description', 'thumbnail']]
    const csvData = categories.map((cv) => [
        cv?.name,
        cv?.description,
        cv?.thumbnail,
    ])
    const exportData = csvHead.concat(csvData);
    const handleStatusChange = (value, idx) => {
        handleStatusSubmit(value, idx);
    }

    const handleStatusSubmit = (value, idx) => {
        setLoading2(false);
        axios.post(`/api/admin/v1/category-priorty-status/status`,
            {
                value: value,
                id: idx,
            }, {
            headers: {
                Authorization: `Bearer ${auth.token}`,
            },
        })
            .then(() => {
                setPrevData({
                    value: "",
                    idx: "",
                });
                setRefresh(refresh => refresh + 1);
                dispatch(getCategoriesList(auth?.token, paginate, page, search, sort, priority))
                toast.success("priorty updated successfully");
            })
            .catch((error) =>
                toast.error("Somthing Went Wrong")
            );
    };
    const handleDel = (id) => {
        if (window.confirm("Are You Sure You Want To Delete This Category")) {
            axios.delete(`/api/admin/v1/delete-category/${id}`, {
                headers: {
                    Authorization: `Bearer ${auth?.token}`
                }
            }).then((res) => {
                    setRefresh(refresh => refresh + 1);
                    toast.success(res.data.message)
                    dispatch(getCategoriesList(auth?.token))
                }
            ).catch((err) => {
                if (err.response && err.response.status === 422) {
                    toast.error(err.response.data.message);
                } else if (err.response && err.response.data?.message) {
                    toast.error(err.response.data.message);
                } else {
                    toast.error("Something went wrong");
                }
            });
        }
    }


    return (
        <div>
            <div className="row my-3">
                <div className="col-md-12">
                    <div className="d-flex align-items-center justify-content-between">
                        <h5 className='mb-0 text-white'>Categories</h5>
                        {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "CATEGORIES" && item?.permission?.permission === "create") && (
                            <Link to="/add-category" >
                                <Button className='bg-white text-black' style={{ color: "primary" }} size='sm' >
                                    <span className='me-2' >
                                        <MdAdd size={22} />
                                    </span>
                                    Add Category
                                </Button>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
            <div className='bg-white px-3 py-4 rounded-2  my-4' style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}  >
                <div className="row">
                    <div className="col-md-2 mb-2 ">
                        <Input size={"sm"} value={search} placeholder='Search By Name' onChange={(({ target: { value } }) => setSearch(value))} />
                    </div>
                    <div className={`col-md-2 ${allowedPermissions?.some?.(
                        (item) =>
                            item?.permission?.moduleType === "CATEGORIES" &&
                            item?.permission?.permission === "export"
                    ) ? "offset-md-7" : "offset-md-8"}`}>
                        <Input type="select" size={"sm"} value={sort} onChange={(({ target }) => setSort(target.value))} >
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                        </Input>
                    </div>
                    {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "CATEGORIES" && item?.permission?.permission === "export") && (
                        <div className="col-md-1 mb-2">
                            <CSVLink
                                filename={
                                    "category-lists.csv"
                                }
                                className="text-black ms-1"
                                title="Export To CSV"
                                data={exportData}
                            >
                                <BiSolidFileExport size={25} />
                            </CSVLink>
                        </div>
                    )}
                    <div className="col-md-12">
                        <Table
                            hover
                            responsive
                        >
                            <thead>
                                <tr>
                                    <th>
                                        SL. No.
                                    </th>
                                    <th>
                                        Name
                                    </th>
                                    <th>
                                        Thumbnail
                                    </th>
                                    <th>
                                        Description
                                    </th>
                                    <th>Priority</th>
                                    {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "CATEGORIES" && (item?.permission?.permission === "edit" || item?.permission?.permission === "delete")) && (
                                        <th>
                                            Action
                                        </th>
                                    )}
                                </tr>
                            </thead>
                            {
                                loading ? <Spinner /> : <tbody>
                                    {categories.length === 0 ? (
                                        <tr>
                                            <td colSpan="6">No data found</td>
                                        </tr>
                                    ) : (<>
                                        {categories?.map?.((item, index) => {
                                            return <tr key={item.id}>

                                                <th scope="row">
                                                    {(index + 1) + (page * paginate)}
                                                </th>
                                                <td>
                                                    {item?.name}
                                                </td>
                                                <td>
                                                    <img
                                                        src={process.env.REACT_APP_IMAGE_URL + `/${item?.thumbnail}`}
                                                        height={45}
                                                        width={45}
                                                    />
                                                </td>
                                                <td>
                                                    {item?.description}
                                                </td>
                                                <td>
                                                    <Input size={"sm"} className="col-md-2"
                                                        type="select"
                                                        name="priority"
                                                        value={item.priority}
                                                        onChange={
                                                            ({ target: { value } }) =>
                                                                handleStatusChange(value, item.id)
                                                        }


                                                    // onChange={(({ target }) => setPriority(target.value))}
                                                    >
                                                        <option value="">Select Priority</option>
                                                        <option value="1" key="1"> 1 </option>
                                                        <option value="2" key="2"> 2 </option>
                                                        <option value="3" key="3"> 3 </option>
                                                        <option value="4" key="4"> 4 </option>
                                                        <option value="5" key="5"> 5 </option>
                                                        <option value="6" key="6"> 6 </option>
                                                        <option value="7" key="7"> 7 </option>
                                                        <option value="8" key="8"> 8 </option>
                                                        <option value="9" key="9"> 9 </option>
                                                        <option value="10" key="10"> 10 </option>
                                                        <option value="11" key="11"> 11 </option>
                                                        <option value="12" key="12"> 12 </option>
                                                        <option value="13" key="13"> 13 </option>
                                                        <option value="14" key="14"> 14 </option>
                                                        <option value="15" key="15"> 15 </option>
                                                    </Input></td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        {
                                                            allowedPermissions?.some?.((item) => item?.permission?.moduleType === "CATEGORIES" && item?.permission?.permission === "edit") &&
                                                            <Link to={`/edit-category/${item?.id}`}>
                                                                <AiOutlineEdit size={22} className='text-warning me-3' />
                                                            </Link>
                                                        }
                                                        {
                                                            allowedPermissions?.some?.((item) => item?.permission?.moduleType === "CATEGORIES" && item?.permission?.permission === "delete") &&
                                                            <AiOutlineDelete size={22} className='text-danger' onClick={() => handleDel(item.id)} />
                                                        }
                                                    </div>

                                                </td>
                                            </tr>
                                        })
                                        }</>
                                    )}
                                </tbody>
                            }
                        </Table>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-md-6 d-flex">
                        <div className="col-md-2">
                            <Input
                                type="select"
                                id="paginate"
                                onChange={(e) =>
                                    setPaginate(
                                        e.target.value
                                    )
                                }
                                value={paginate}
                                className="paging custom-select custom-select-page m-0"
                            >
                                <option value="10" selected>
                                    10
                                </option>
                                <option value="20">
                                    20
                                </option>
                                <option value="50">
                                    50
                                </option>
                                <option value="100">
                                    100
                                </option>
                                <option value="200">
                                    200
                                </option>
                                <option value="500">
                                    500
                                </option>
                            </Input>
                        </div>
                        <div className='col-md-10 text-black d-flex align-items-center ps-3'>
                            {categoriesCount > 0 ? (
                                <>
                                    Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, categoriesCount)} of {categoriesCount} entries
                                </>
                            ) : (
                                <>
                                    Showing 0 to 0 of 0 entries
                                </>
                            )}
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='d-flex justify-content-end'>
                            <Pagination pageCount={categoriesCount / paginate} onChange={(e) => setPage(e.selected)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Category